
export const makeOrderedMyLinks = (links, ordering) => {
	let orderedLinks = [];
	if(Array.isArray(ordering)) {
		ordering.map(item => {
			if (typeof item === 'string') {
				let findLink = links.find(link => link.linkId === item)
				if (findLink) {
					orderedLinks.push(findLink)
				}
				return item
			}
		})
	}

	return orderedLinks.concat(links.filter(link =>
		!orderedLinks.find(ordered =>
			ordered.linkId === link.linkId
		)
	))
}

